<template>
  <div class="spotlight-guide" ref="spotlightGuide">
    <!-- intro.js 是纯 JS 驱动，无需模板内容 -->
  </div>
</template>

<script>
import introJs from 'intro.js'
import 'intro.js/introjs.css'

export default {
  name: 'SpotlightGuide',
  props: {
    // 是否自动销毁（默认 true）
    autoDestroy: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      introInstance: null
    }
  },
  beforeDestroy() {
    this.destroy()
  },
  methods: {
    /**
     * 启动引导
     * @param {Array} steps - 步骤数组 [{ element, intro, position }]
     * @param {Object} options - 额外配置
     * @returns {introJs} intro.js 实例
     */
    start(steps, options = {}) {
      // 确保 DOM 已渲染
      this.$nextTick(() => {
        const defaultOptions = {
          steps: steps || [],
          exitOnOverlayClick: false,
          exitOnEsc: true,
          showStepNumbers: true,
          showBullets: true,
          showProgress: false,
          disableInteraction: true,
          nextLabel: '下一步 →',
          prevLabel: '← 上一步',
          skipLabel: '跳过',
          doneLabel: '完成',
          scrollToElement: true,
          // scrollPadding 设为 100，确保目标元素下方有足够空间展示 tooltip
          // 避免 intro.js 检测到空间不足时自动将 position: 'bottom' 翻转为 'top'
          scrollPadding: 100,
          ...options
        }

        this.introInstance = introJs()
        this.introInstance.setOptions(defaultOptions)

        // 绑定事件回调
        if (options.onComplete) {
          this.introInstance.oncomplete(options.onComplete)
        }
        if (options.onExit) {
          this.introInstance.onexit(options.onExit)
        }
        if (options.onChange) {
          this.introInstance.onchange(options.onChange)
        }
        if (options.onBeforeChange) {
          this.introInstance.onbeforechange(options.onBeforeChange)
        }

        this.introInstance.start()
      })
      return this.introInstance
    },

    /**
     * 跳转到指定步骤
     * @param {number} stepIndex - 步骤索引（从 1 开始）
     */
    goToStep(stepIndex) {
      if (this.introInstance) {
        this.introInstance.goToStep(stepIndex)
      }
    },

    /**
     * 退出引导
     */
    exit() {
      if (this.introInstance) {
        this.introInstance.exit()
      }
    },

    /**
     * 刷新引导（目标元素变化后调用）
     */
    refresh() {
      if (this.introInstance) {
        this.introInstance.refresh()
      }
    },

    /**
     * 销毁实例
     */
    destroy() {
      if (this.introInstance) {
        this.introInstance.exit()
        this.introInstance = null
      }
    }
  }
}
</script>

<style scoped>
.spotlight-guide {
  display: none;
}
</style>
